import styled from "styled-components";

export const MainContent = styled.main`
  max-width: 136.8rem;
  min-height: 74.2rem;
  margin: 0 auto;
  padding: 3.2rem 1rem;
  & > ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 5.6rem;
    width: 100%;
  }
  @media (max-width: 680px) {
    & > ul {
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: scroll;
      width: 100%;
      gap: 2.6rem;
    }
    & > ul::-webkit-scrollbar {
      appearance: none;
    }
  }
`;
